import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Luis', 'Patricia', 'José', 'Carmen', 'Diego', 'Laura', 'Roberto'];
const CITIES = ['Bogotá', 'Ciudad de México', 'Buenos Aires', 'Lima', 'Santiago', 'Medellín', 'Guadalajara', 'Montevideo', 'Quito', 'Caracas'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const time = Math.floor(Math.random() * 59) + 1; // 1 to 60 minutes
      setNotification({
        name,
        city,
        time
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000);
    // Recurring interval (random between 8-15 seconds + 4s display time)
    const intervalId = setInterval(() => {
      if (!isVisible) {
        const randomDelay = Math.floor(Math.random() * 7000) + 8000; // 8-15 seconds
        setTimeout(showNotification, randomDelay);
      }
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-left-10 fade-in duration-500" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-[#4a7c2c] max-w-xs" data-id="element-2">
        <div className="bg-[#f0f7eb] p-2 rounded-full flex-shrink-0" data-id="element-3">
          <ShoppingBag className="w-5 h-5 text-[#4a7c2c]" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            {notification.name} de {notification.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-7">
            compró hace {notification.time} minutos
          </p>
        </div>
      </div>
    </div>;
}